import React from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: SelectOption[];
}
export function Select({
  label,
  options,
  className = '',
  ...props
}: SelectProps) {
  return <div className="relative" data-id="element-312">
      {label && <label className="block text-xs font-medium text-slate-500 mb-1 uppercase tracking-wider" data-id="element-313">
          {label}
        </label>}
      <div className="relative" data-id="element-314">
        <select className={`appearance-none w-full bg-white border border-slate-300 text-slate-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block p-2.5 pr-8 ${className}`} {...props} data-id="element-315">
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-316">
              {opt.label}
            </option>)}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-slate-500" data-id="element-317">
          <ChevronDown className="h-4 w-4" data-id="element-318" />
        </div>
      </div>
    </div>;
}